// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `span.edit-upload-field {
    border: 1px solid var(--border-color);
    display: flex;
    align-items: center;
    background-color: var(--input-bg-color);
    padding: 0.25em;
}

span.edit-upload-field > a {
    flex: 1 1 auto;
    white-space: nowrap;
}

span.edit-upload-field > span.icon {
    flex: 0 0 auto;
}

span.edit-upload-field-input {
    display: flex;
    align-items: center;
}

span.edit-upload-field-input > input {
    min-width: 8em;
    width: 0;
    flex: 1 1 auto;
}

span.edit-upload-field-input > span.icon {
    flex: 0 0 auto;
    margin: 0 0.25em;
}

span.edit-upload-field-disabled,
span.edit-upload-field-input-disabled {
    background-color: var(--input-bg-color-disabled);
    color: var(--text-color-disabled);
}

span.edit-upload-field-image {
    display: flex;
    flex-direction: column;
    max-width: 150px;
}

span.edit-upload-field-image > img {
    width: 100%;
    flex: 1 1 auto;
    cursor: pointer;
}

span.edit-upload-field-image > div.ButtonBar {
    margin: 0;
}

span.edit-upload-field-imagelink {
    position: relative;
    text-align: left;
}

span.edit-upload-field-imagelink > img {
    display: none;
    position: absolute;
    max-width: 240px;
    max-height: 240px;
    top: 100%;
    z-index: 1;
    box-shadow: 0px 2px 4px rgba(136, 136, 136, 0.5);
    cursor: pointer;
}

span.edit-upload-field-imagelink:hover > img {
    display: initial;
}

video.edit-capture-frame {
    height: 100%;
    max-width: 100%;
}

div.edit-capture-controls {
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 1em;
    left: 0;
    right: 0;
}

div.edit-capture-controls > span.icon {
    font-size: 300%;
    background-color: rgba(255, 255, 255, 0.75);
    padding: 0.3em;
    border-radius: 1em;
}
`, "",{"version":3,"sources":["webpack://./qwc2/components/style/EditUploadField.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,gDAAgD;IAChD,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,UAAU;IACV,gDAAgD;IAChD,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,2CAA2C;IAC3C,cAAc;IACd,kBAAkB;AACtB","sourcesContent":["span.edit-upload-field {\r\n    border: 1px solid var(--border-color);\r\n    display: flex;\r\n    align-items: center;\r\n    background-color: var(--input-bg-color);\r\n    padding: 0.25em;\r\n}\r\n\r\nspan.edit-upload-field > a {\r\n    flex: 1 1 auto;\r\n    white-space: nowrap;\r\n}\r\n\r\nspan.edit-upload-field > span.icon {\r\n    flex: 0 0 auto;\r\n}\r\n\r\nspan.edit-upload-field-input {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\nspan.edit-upload-field-input > input {\r\n    min-width: 8em;\r\n    width: 0;\r\n    flex: 1 1 auto;\r\n}\r\n\r\nspan.edit-upload-field-input > span.icon {\r\n    flex: 0 0 auto;\r\n    margin: 0 0.25em;\r\n}\r\n\r\nspan.edit-upload-field-disabled,\r\nspan.edit-upload-field-input-disabled {\r\n    background-color: var(--input-bg-color-disabled);\r\n    color: var(--text-color-disabled);\r\n}\r\n\r\nspan.edit-upload-field-image {\r\n    display: flex;\r\n    flex-direction: column;\r\n    max-width: 150px;\r\n}\r\n\r\nspan.edit-upload-field-image > img {\r\n    width: 100%;\r\n    flex: 1 1 auto;\r\n    cursor: pointer;\r\n}\r\n\r\nspan.edit-upload-field-image > div.ButtonBar {\r\n    margin: 0;\r\n}\r\n\r\nspan.edit-upload-field-imagelink {\r\n    position: relative;\r\n    text-align: left;\r\n}\r\n\r\nspan.edit-upload-field-imagelink > img {\r\n    display: none;\r\n    position: absolute;\r\n    max-width: 240px;\r\n    max-height: 240px;\r\n    top: 100%;\r\n    z-index: 1;\r\n    box-shadow: 0px 2px 4px rgba(136, 136, 136, 0.5);\r\n    cursor: pointer;\r\n}\r\n\r\nspan.edit-upload-field-imagelink:hover > img {\r\n    display: initial;\r\n}\r\n\r\nvideo.edit-capture-frame {\r\n    height: 100%;\r\n    max-width: 100%;\r\n}\r\n\r\ndiv.edit-capture-controls {\r\n    display: flex;\r\n    justify-content: center;\r\n    position: absolute;\r\n    bottom: 1em;\r\n    left: 0;\r\n    right: 0;\r\n}\r\n\r\ndiv.edit-capture-controls > span.icon {\r\n    font-size: 300%;\r\n    background-color: rgba(255, 255, 255, 0.75);\r\n    padding: 0.3em;\r\n    border-radius: 1em;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
